import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Snackbar from '@mui/material/Snackbar';
import { Box, Alert as MuiAlert } from '@mui/material';
import { alert } from '../../state';

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const AlertBar = ({
  message,
  severity,
  timeout,
  open,
  closeAlert,
  clearAlert,
}) => {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    closeAlert(false);
    setTimeout(() => clearAlert(), 1000);
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={open}
      autoHideDuration={timeout}
      onClose={handleClose}
    >
      <Box minWidth={350} maxWidth="calc(100vw - 32px)">
        <Alert
          onClose={handleClose}
          severity={severity}
          style={{ whiteSpace: 'pre-line' }}
        >
          {message}
        </Alert>
      </Box>
    </Snackbar>
  );
};
AlertBar.defaultProps = {
  message: 'Oops something went wrong',
};

AlertBar.propTypes = {
  message: PropTypes.string,
  severity: PropTypes.string.isRequired,
  timeout: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  closeAlert: PropTypes.func.isRequired,
  clearAlert: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  severity: alert.selectors.selectSeverity(state),
  message: alert.selectors.selectMessage(state),
  open: alert.selectors.selectOpen(state),
  timeout: alert.selectors.selectTimeout(state),
});
const mapDispatchToProps = (dispatch) => ({
  closeAlert: (payload) => dispatch(alert.actions.close(payload)),
  clearAlert: () => dispatch(alert.actions.clear()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertBar);
